<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Weapon Skin Synthesis"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        Recycle certain weapon skins to combine 10 skins of the same quality into <strong>a higher-quality weapon
          skin</strong>.
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>